/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'
import { Table, Divider, Icon } from 'antd'
import { accountingAction } from '../../action/accounting'
import { GeneralStyles } from '../../styles/general'

import BusinessStatus from '../../business/status'
import StatusTag from '../../components/StatusTag'

import UserViewer from '../../components/business/UserViewer'

interface IRechargeListProps {}

interface IRechargeListState {
  pageList: any[]

  loading: boolean

  pagination: {
    current: number
    total: number
    size: number
  }
}

interface RechargeList {
  props: IRechargeListProps
  state: IRechargeListState
}

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '交易id',
    dataIndex: 'trade_id',
    key: 'trade_id',
    // render: (text: any) => <a href="#">{text}</a>,
  },{
    title: '用户',
    dataIndex: 'uid',
    key: 'uid',
    render: (text: any) => <UserViewer uid={text}/>,
  },
  {
    title: '充值金额',
    dataIndex: 'charge_amount',
    key: 'charge_amount',
  },
  {
    title: '充值前余额',
    dataIndex: 'before_balance',
    key: 'before_balance',
  },
  {
    title: '充值后余额',
    dataIndex: 'after_balance',
    key: 'after_balance',
  },
  {
    title: '支付渠道',
    dataIndex: 'pay_channel',
    key: 'pay_channel',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '状态',
    key: 'pay_status',
    dataIndex: 'pay_status',
    render: (status: any, item: any) => {
      return (
        <span>
          <StatusTag item={item} status={status} config={BusinessStatus.recharge}/>
        </span>
      )
    },
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => (
      <span>
        <a href="#">查看</a>
        <Divider type="vertical" />
        <a href="#">更多</a>
      </span>
    ),
  },
]

@observer
class RechargeList extends Component {
  constructor(props: IRechargeListProps) {
    super(props)

    this.state = {
      loading: true,
      pageList: [],
      pagination: {
        current: 1,
        total: 0,
        size: 10,
      },
    }
  }

  fetchRechargeList = (condition?: any) => {
    this.setState((prevState: IRechargeListState, props: IRechargeListProps) => ({
      loading: true,
    }))
    return accountingAction.fetchRechargeList(condition).catch(err => {
      this.setState((prevState: IRechargeListState, props: IRechargeListProps) => ({
        loading: false,
      }))
    })
  }

  componentDidMount() {
    this.fetchRechargeList().then((responseData) => {
      this.setState((prevState: IRechargeListState, props: IRechargeListProps) => ({
        loading: false,
        pageList: responseData.list,
        pagination: {
          ...prevState['pagination'],
          total: responseData.total,
        },
      }))
    })
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === this.state.pagination.current) {
      return
    }

    this
      .fetchRechargeList({ pn: pagination['current'] })
      .then((responseData) => {
        this.setState((prevState: IRechargeListState, props: IRechargeListProps) => ({
          loading: false,
          pageList: responseData.list,
          pagination: {
            ...prevState['pagination'],
            current: pagination['current'],
            total: responseData.total,
          },
        }))
      })
  }

  render() {
    const pageList = this.state.pageList.map((item: any) => {
      return {
        key: item['uid'],
        ...item,
      }
    })

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="money-collect" /> 充值记录</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']}>
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.id}
              dataSource={pageList}
              pagination={{
                total: this.state.pagination.total,
                pageSize: this.state.pagination.size,
              }}
              loading={this.state.loading}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default RechargeList
